<template>
  <!--编辑节点-->
  <div class="secondNodeBg">
    <div class="secondNodeEdit">
      <div class="edit-header">
        <h3>节点编辑</h3>
        <em @click="closeWindow">关闭</em>
      </div>
      <el-form
        ref="nodeEditForm"
        :model="nodeEditForm"
        label-width="80px">
        <el-form-item label="节点标题">
          <el-input
            v-permission="[1]"
            v-model="nodeEditForm.data.title"/>
          <span>{{ nodeEditForm.data.title }}</span>
        </el-form-item>
        <el-form-item label="节点备注">
          <el-input v-model="nodeEditForm.data.mark"/>
        </el-form-item>
        <el-form-item label="选择商品">
          <el-checkbox-group v-model="nodeEditForm.data.article_list">
            <el-checkbox
              v-for="items in nodeEditForm.article_list"
              :label="items.id"
              :key="items.id"
              :title="items.title">{{ items.title }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="首件商品">
          <el-select
            v-model="nodeEditForm.data.frist_id"
            placeholder="请选择">
            <el-option
              :value="0"
              :key="0"
              label="请选择"/>
            <el-option
              v-for="items in nodeEditForm.data.article_list"
              :key="items"
              v-if="nodeEditForm.article_list[items]"
              :label="nodeEditForm.article_list[items].title"
              :value="items"/>
          </el-select>
        </el-form-item>
        <el-form-item label="是否全程">
          <el-select
            v-model="nodeEditForm.data.is_all"
            placeholder="请选择">
            <el-option
              :key="1"
              label="是"
              :value="1"/>
            <el-option
              :key="0"
              label="否"
              :value="0"/>
          </el-select>
        </el-form-item>
        <el-button
          @click="detailSave"
          type="primary">保存</el-button>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hiddenBtn: {
      type: Boolean,
      default: false
    },
    nodeId: {
      type: Number,
      default: 0
    },
    countryId: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      nodeEditForm: {
        article_list: {},
        data: {
          title: '',
          mark: '',
          article_list: [],
          frist_id: '',
          is_all: '',
        }
      },
    };
  },
  methods: {
    getDataDetail() {
      this.$http._get({
        url: `/index/Second_sales/getDetail?id=${this.nodeId}&country_id=${this.countryId}`,
      }).then((data) => {
        if (this.nodeId !== 0) {
          this.nodeEditForm = data.data;
        } else {
          this.nodeEditForm.data.country_str = data.data.data.country_str;
          this.nodeEditForm.article_list = data.data.article_list;
        }
        console.log(this.nodeEditForm.data.article_list);
      });
    },
    closeWindow() {
      this.$emit('update:hiddenBtn', false);
    },
    detailSave() {
      let listData = {
        ...this.nodeEditForm.data
      };
      this.$http._post({
        url: '/index/Second_sales/edit',
        data: listData,
      }).then(() => {
        this.$message.success('保存成功');
        this.$parent.getData();
        this.closeWindow();
      });
    }
  },
  mounted() {
    this.getDataDetail();
  },
  watch: {
    hiddenBtn(val) {
      console.log(val);
      if (val) {
        this.getDataDetail();
      }
    }
  }
};
</script>
<style scoped>
  .el-checkbox{
    margin-left: 0;
    margin-right: 15px;
  }
  .secondNodeEdit{
    position: fixed;
    left:50%;
    top:12%;
    z-index:3;
    width: 800px;
    margin-left: -400px;
    background: #fff;
    padding:15px;
    box-shadow: 0 0 10px 0 rgba(0,0,0,.2);
    -webkit-border-radius: 10px; -moz-border-radius: 10px; border-radius: 10px;
  }
  .secondNodeEdit .el-checkbox-group{
    overflow-y: auto;
    height:300px;
  }
  .secondNodeEdit .el-checkbox{
    width: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .secondNodeEdit .edit-header{
    border-bottom: 1px solid #dfe6ec;
    margin-bottom: 15px;
    padding-bottom: 10px;
    overflow: hidden;
  }
  .secondNodeEdit .edit-header h3{
    font-size:18px;
    float: left;
  }
  .secondNodeEdit .edit-header em{
    float: right;
    display: inline-block;
    width: 60px;
    height:24px;
    line-height:24px;
    text-align: center;
    background: #20a0ff;
    color: #fff;
    cursor: pointer;
    -webkit-border-radius: 4px; -moz-border-radius: 4px; border-radius: 4px;
  }
  .secondNodeEdit .edit-header em:hover{
    opacity:0.8;
  }
  .secondNodeBg{
    display: block;
    content: "";
    position: fixed;
    left:0;
    top:0;
    z-index: 4;
    width: 100%;
    height:100%;
    background: rgba(0,0,0,.4);
  }
</style>
